var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',{staticClass:"txt_arial"},[_vm._v("Copyright © 1998-"+_vm._s(_vm.newYear)+" DRCnet. All Rights Reserved")]),_vm._v(" 版权所有 国研网 ")])}
var staticRenderFns = []

export { render, staticRenderFns }